import FreeSpeech from './FreeSpeech';

export default FreeSpeech;
